module.exports = __webpack_public_path__ + "img/email.0a1d7b29.svg";